import { EnvironmentProviders } from '@angular/core';

import {
  DocumentManagementOrganizationSettingsPermissions,
  PurchaseRequisitionsPermissions,
  createPurchaseRequisitionOrganizationSettingsPlugin,
} from '@mp/document-management/core';
import { provideModuleInfo } from '@mp/shared/util';
import { provideModuleOrganizationSettings, provideModulePermissions } from '@mpk/shared/data-access';

const moduleName = 'DocumentManagement';

export function provideDocumentManagementFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Belege',
    }),
    provideModulePermissions(
      moduleName,
      PurchaseRequisitionsPermissions,
      DocumentManagementOrganizationSettingsPermissions,
    ),
    provideModuleOrganizationSettings('Moduleinstellungen', createPurchaseRequisitionOrganizationSettingsPlugin),
  ];
}
